import TextBox from 'components/TextBox'

const TipOption = ({
  value,
  handleSaveTipOption,
  name,
  isOther = false,
  header,
}) => {
  return (
    <div className="content-wrapper min-height-60">
      <span className="content-header">{header}</span>
      {isOther ? (
        <span className="content-value color-disabled">Other</span>
      ) : (
        <div className="input-short">
          <TextBox
            name={name}
            percentage
            percentageCenter
            maxLength={3}
            placeholder="-"
            value={value ?? ''}
            onChange={(e) => handleSaveTipOption(e.target.value)}
          />
        </div>
      )}
    </div>
  )
}

export default TipOption
